export const ioKindList = [
  { name: "ورودی", value: 0 },
  { name: "خروجی", value: 1 },
];
